// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router/routers'
import './router/index'
// import router from './router/index'
import store from './store'

import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import prismCss from './plugins/prism.css'
import prismjs from './plugins/prism'
import './styles/var.scss'
import './styles/common.scss'
import './styles/element-variables.scss'
import Config from '@/utils/config'
// import GlobalVar from './utils/globalSettings'
import './assets/icons' // icon

Vue.use(ElementUI)
Vue.use(prismCss)
Vue.use(prismjs)
Vue.prototype.Config = Config
// Vue.prototype.GlobalVar = GlobalVar
Vue.config.productionTip = false
setTimeout(() => {
  prismjs.highlightAll()
}, 1000)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js